<div class="p-2 desktop-padding-margin col-xl-6 m-auto">
  <div>
    @if (showForm) {
      <ng-container class="col-md-12">
        <!-- non paymnet related view, ie when any trial coupons is applied-->
        @if (trialCoupon && isCouponApplied) {
          <!-- Display the applied coupon with a remove option -->
          <div class="mt-3">
            <h5 class="plan-name">
              {{ dataAfterCouponApplied.name }}
            </h5>
          </div>
          <div class="mb-2 mt-2">
            Coupon applied for a {{ dataAfterCouponApplied?.trial_days }} day
            trial
          </div>
          <div class="d-flex mb-3 align-items-center">
            <span
              >Coupon <span class="fw-semibold">{{ couponCode }}</span> Applied
            </span>
            <button
              (click)="removeAppliedCoupon()"
              class="btn btn-sm btn-outline-danger ms-2"
            >
              Remove
            </button>
          </div>
          <div class="row row-cols-2 mt-3">
            <div class="col">
              <button class="btn btn-dark" (click)="onCloseDialogue()">
                Cancel
              </button>
            </div>
            <div class="col">
              <button
                class="btn btn-primary"
                id="card-pay-btn"
                (click)="applyTrialCoupon()"
              >
                Continue
              </button>
            </div>
          </div>
        }
        <!-- payment related view-->
        @if (!trialCoupon) {
          @if (existingSlots) {
            <!--add user slots case-->
            <div class="mb-2">
              <div>
                <div class="row">
                  <div class="align-self-center col-lg-4 col-sm-12">
                    Add Additional User(s) <br />
                    {{ regionCurrencySymbol
                    }}{{ selectedPlan?.user_cost.toFixed(2) }}
                    each per month
                  </div>
                  <div class="col-lg-6 col-sm-12">
                    <div class="counter-buttons">
                      <button
                        class="m-1 btn btn-outline-primary"
                        (click)="decrement()"
                        [disabled]="minAllottedSlots >= allottedSlots"
                      >
                        -
                      </button>
                      <span class="mx-3 fw-bold">{{ allottedSlots }}</span>
                      <button
                        class="m-1 btn btn-outline-primary"
                        (click)="increment()"
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3 mt-1">
              <span> Total Users: </span>

              <span>
                {{ existingSlots }} >>>
                <span class="fs-5">
                  {{ existingSlots + allottedSlots }}
                </span>
              </span>
            </div>
          }
          @if (!existingSlots) {
            <!-- periodic subscription case-->
            <div class="mb-2 mt-3">
              <h5 class="plan-name mb-2">
                {{ selectedPlan?.name }}
              </h5>
              <div class="mb-4">
                Includes {{ selectedPlan?.allowed_users }} Users
              </div>
              @if (selectedPlan?.trial_days && isTrialApplicable) {
                <div>
                  <span class="fw-bold"> $0 </span>
                  for the first {{ selectedPlan.trial_days }} days limited to
                  {{ selectedPlan?.trial_users_allowed }} users
                  <div class="my-1">then</div>
                </div>
              }
              <div>
                <span
                  >{{ regionCurrencySymbol
                  }}{{ (selectedPlan?.final_amount).toFixed(2) }}</span
                >
                per month
              </div>
              @if (selectedPlan?.plan_type == 2) {
                <!-- transaction price payment plan-->
                <br />
                <span class="small"
                  >{{ selectedPlan?.allowed_transactions }} transactions
                  included</span
                >
                <br />
                <span class="small"
                  >{{ getRoundOffValue(selectedPlan?.transaction_price) }}c per
                  transaction thereafter</span
                >
              }
              @if (selectedPlan?.plan_type == 1) {
                <!-- user price payment plan-->
                <div>
                  {{ regionCurrencySymbol
                  }}{{
                    getRoundOffValue(selectedPlan?.user_cost, false).toFixed(2)
                  }}
                  per additional user
                </div>
                <!-- case where this is not the first subscription or there is no trial days in the plan or the user is beta-->
                @if (!selectedPlan?.trial_days || !isTrialApplicable) {
                  <div class="mt-4">
                    <div>
                      <div class="row">
                        <div
                          class="align-self-center col-md-3 col-lg-2 col-xl-2 col-sm-12 mt-0"
                        >
                          Additional Users
                        </div>
                        <div class="col-lg-4 col-sm-9 mt-0">
                          <div class="counter-buttons">
                            <button
                              class="m-1 btn btn-outline-primary"
                              (click)="decrement()"
                              [disabled]="minAllottedSlots >= allottedSlots"
                            >
                              -
                            </button>
                            <span class="mx-3 fw-bold">{{
                              allottedSlots - selectedPlan?.allowed_users
                            }}</span>
                            <button
                              class="m-1 btn btn-outline-primary"
                              (click)="increment()"
                            >
                              +
                            </button>
                          </div>
                        </div>
                      </div>
                      <ng-container>
                        <div class="mb-3">
                          <!-- Headers -->
                          <div class="row row-cols-4 mb-3">
                            <div class="col-6 fw-bold"></div>
                            <div class="col-1 px-1 fw-bold text-center">
                              Qty
                            </div>
                            <div class="col-3 px-2 fw-bold text-end">
                              Unit Price
                            </div>
                            <div class="col-2 px-1 fw-bold text-end">
                              Sub Total
                            </div>
                          </div>
                          <!-- Base Plan -->
                          <div class="row row-cols-4 mb-3">
                            <div class="col-6">
                              {{ selectedPlan?.name }} <br />(Includes
                              {{ selectedPlan?.allowed_users }} Users)
                            </div>
                            <div class="col-1 px-1 text-center">1</div>
                            <div class="col-3 px-1 text-end">
                              {{ regionCurrencySymbol
                              }}{{ (selectedPlan?.final_amount).toFixed(2) }}
                            </div>
                            <div class="col-2 px-1 text-end">
                              {{ regionCurrencySymbol
                              }}{{ (selectedPlan?.final_amount).toFixed(2) }}
                            </div>
                          </div>
                          <!-- Additional Guards -->
                          @if (
                            allottedSlots - selectedPlan?.allowed_users > 0
                          ) {
                            <div class="row row-cols-4 mb-3">
                              <div class="col-6">Additional User</div>
                              <div class="col-1 px-1 text-center">
                                {{
                                  allottedSlots - selectedPlan?.allowed_users
                                }}
                              </div>
                              <div class="col-3 px-1 text-end">
                                {{ regionCurrencySymbol
                                }}{{ getUserCost().toFixed(2) }}
                              </div>
                              <div class="col-2 px-1 text-end">
                                {{ regionCurrencySymbol
                                }}{{
                                  (
                                    getUserCost() *
                                    (allottedSlots -
                                      selectedPlan?.allowed_users)
                                  ).toFixed(2)
                                }}
                              </div>
                            </div>
                          }
                          <!-- reserved user billing info-->
                          @if (reservedUserBillingInfo) {
                            <div class="row row-cols-4 mb-3">
                              <div
                                class="col-6 fw-semibold"
                                role="button"
                                (click)="openReserveUserBillingTemplate()"
                              >
                                Casual User Fees
                                <span
                                  ><i class="fa-solid fa-circle-info fs-6"></i
                                ></span>
                              </div>
                              <div class="col-1 px-1 text-center">
                                {{ reservedUserBillingInfo?.total_count }}
                              </div>
                              <div class="col-3 px-1 text-end">
                                {{ regionCurrencySymbol
                                }}{{
                                  reservedUserBillingInfo?.per_day_per_guard_price?.toFixed(
                                    2
                                  )
                                }}
                              </div>
                              <div class="col-2 px-1 text-end">
                                {{ regionCurrencySymbol
                                }}{{
                                  (reservedUserBillingInfo
                                    ?.total_amount).toFixed(2)
                                }}
                              </div>
                            </div>
                          }
                          <div class="fw-bold mt-2 text-end">
                            {{ allottedSlots }} Users Total
                          </div>
                          <div class="fw-bold mt-2 text-end">
                            {{ regionCurrencySymbol
                            }}{{ getPaymentAmount() }} Total
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                }
              }
            </div>
          }
          @if (isCouponApplied) {
            <!-- Display the applied coupon with a remove option -->
            <div class="d-flex my-3 align-items-center">
              <span
                >Coupon
                <span class="fw-semibold">{{ couponCode }}</span> Applied
              </span>
              <button
                (click)="removeAppliedCoupon()"
                class="btn btn-sm btn-danger ms-2"
              >
                Remove
              </button>
            </div>
          }
          @if (showCouponInput && !isCouponApplied) {
            <div class="d-flex">
              <input
                class="form-control flex-grow-1 me-2"
                type="text"
                [(ngModel)]="couponCode"
                id="couponCode"
                placeholder="Coupon code"
                (input)="forceUppercaseConditionally($event)"
              />
              <button
                class="mt-0"
                class="btn btn-primary btn-lg"
                (click)="onApplyCouponCode()"
                [disabled]="!couponCode"
              >
                Apply
              </button>
            </div>
            @if (errorCouponCode === true) {
              <div class="text-danger">Invalid coupon</div>
            }
          }
          @if (!showCouponInput && !existingSlots && !isSubscriberLocked) {
            <div class="text-end">
              <button
                class="btn btn-primary fw-semibold btn mb-2"
                (click)="showCouponInput = !showCouponInput"
              >
                Apply Coupon
              </button>
            </div>
          }
          @if (isPaidPlan()) {
            <div>
              <div class="row row-cols-2">
                @if (!showSqForm && savedPaymentCards?.length > 0) {
                  <div class="col-8 col-sm-8 col-md-9 fw-bold">Select Card</div>
                }
                <div class="row-cols-1 mx-auto">
                  @if (showSqForm && savedPaymentCards?.length > 0) {
                    <button
                      class="mb-0 btn btn-success"
                      (click)="
                        showSqForm = false; paymentFormInitialized = false
                      "
                    >
                      Saved Cards
                    </button>
                  }
                </div>
              </div>
              @if (savedPaymentCards?.length && !showSqForm) {
                <div
                  class="mt-1"
                  [ngClass]="largeView ? 'flex-row flex-wrap' : ''"
                >
                  <gtapp-saved-cards
                    (getSavedCards)="getSavedCards()"
                    (selectCard)="checkCardExpiration($event)"
                    [savedCards]="savedPaymentCards"
                  >
                  </gtapp-saved-cards>
                  <br />
                </div>
              }
              <!-- Add the coupon code input field -->
              <!-- LOAD CARDHOLDER NAME AND SQUARE CARD INPUT FIELDS -->
              @if (showSqForm && !processing) {
                <input
                  class="form-control mt-3 lh-lg mb-2"
                  type="text"
                  [(ngModel)]="cardHolderName"
                  id="name"
                  placeholder="Name"
                />
              }
              @if (showSqForm && !processing) {
                <div id="card-container"></div>
              }
              <div>
                @if (showSqForm) {
                  <div>
                    Please note that we do not save your credit card details.
                    These details are saved securely via our payment partner
                    @if (!isPWAApp) {
                      <a
                        href="https://squareup.com/au/en/legal/general/ua"
                        target="_"
                        >SquareUp</a
                      >
                    }
                    @if (isPWAApp) {
                      <span>SquareUp</span>
                    }
                    .
                  </div>
                }
                @if (existingSlots) {
                  <div class="mb-3">
                    <!-- Headers -->
                    <div class="row row-cols-4">
                      <div class="col-6 fw-bold"></div>
                      <div class="col-1 px-1 fw-bold text-center">Qty</div>
                      <div class="col-3 px-2 fw-bold text-end">Unit Price</div>
                      <div class="col-2 px-1 fw-bold text-end">Total</div>
                    </div>
                    <!-- Values -->
                    <div class="row row-cols-4">
                      <div class="col-6">
                        Additional User <br />
                        @if (currentSubscription?.recurring_plan) {
                          <span
                            >Renews
                            {{
                              getBillingDate(currentSubscription)
                                | date: "d MMMM y"
                            }}</span
                          >
                        }
                      </div>
                      <div class="col-1 px-1 text-center">
                        {{ allottedSlots }}
                      </div>
                      <div class="col-3 px-1 text-end">
                        {{ regionCurrencySymbol }}{{ getUserCost().toFixed(2) }}
                      </div>
                      <div class="col-2 px-1 text-end">
                        {{ regionCurrencySymbol }}{{ getPaymentAmount() }}
                      </div>
                    </div>
                  </div>
                }
                @if (!selectedPlan?.trial_days || !isTrialApplicable) {
                  <div>
                    <div class="mt-2 text-end">
                      <div class="row row-cols-2">
                        @if (dataAfterCouponApplied?.applicableDiscount) {
                          <div class="col">Discount</div>
                          <div>
                            - {{ regionCurrencySymbol
                            }}{{
                              dataAfterCouponApplied?.applicableDiscount?.toFixed(
                                2
                              )
                            }}
                          </div>
                        }
                        <div class="col">GST</div>
                        <div>
                          {{ regionCurrencySymbol }}{{ getGSTAmount() }}
                        </div>
                        <div class="col fw-bold">Total with GST</div>
                        <div>
                          {{ regionCurrencySymbol }}{{ getPaymentAmount() }}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                <div class="text-end mt-2 small">
                  Change plans later or cancel at any time
                </div>
              </div>
            </div>
          }
          <div class="my-3">
            {{ pricingDescription }}
          </div>
          <div class="row row-cols-2 mt-2">
            <div class="col">
              @if (!isSubscriberLocked) {
                <button
                  class="btn btn-dark btn-lg w-100"
                  (click)="onCloseDialogue()"
                >
                  Cancel
                </button>
              }
            </div>
            <div class="col">
              @if (this.isPaidPlan()) {
                @if (showSqForm && !processing) {
                  <button
                    ng-container
                    class="btn btn-primary btn-lg w-100"
                    [disabled]="!cardHolderName"
                    id="pay-btn"
                  >
                    Pay
                  </button>
                }
                @if (!showSqForm) {
                  <button
                    id="card-pay-btn "
                    class="btn btn-primary btn-lg w-100"
                    [disabled]="
                      !selectedPlan.selectedCard || paymentFormInitialized
                    "
                    (click)="onCardSelected()"
                  >
                    Pay
                  </button>
                }
                <div id="payment-status-container"></div>
              }
              @if (!this.isPaidPlan()) {
                <div>
                  <button
                    class="btn btn-primary btn-lg w-100"
                    (click)="createSubscription()"
                  >
                    Next
                  </button>
                </div>
              }
            </div>
          </div>
        }
      </ng-container>
    }
  </div>
</div>
